import React from "react";
import PropTypes from "prop-types";

import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  MoreOutlined,
  ShareAltOutlined,
  UserSwitchOutlined,
  BookOutlined,
  FileAddOutlined,
  FileProtectOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

import { Dropdown, Button, Menu } from "antd";

// TODO refactor this to receive menu items rather than objects
/**
 * @function
 * @name ListItemActions
 * @description Render Dropdown component with has actions for list items
 * @param {object} props props object
 * @param {object} props.edit on edit action callback
 * @param {object} props.share on share action callback
 * @param {object} props.onMapPreview on map preview action
 * @param {object} props.view on view action
 * @param {object} props.reload on reload action
 * @param {object} props.archive on archive action callback
 * @param {object} props.components on add components
 * @returns {object} react element
 * @version 0.1.0
 * @since 0.1.0
 */
const ListItemActions = ({
  onMapPreview,
  view,
  edit,
  share,
  createSurvey,
  archive,
  assignPermissions,
  component,
  subComponent,
  fillSurvey,
  downloadReport,
  openIssues,
}) => {
  const items = [];

  if (view) {
    items.push({
      key: "view",
      label: (
        <span onClick={view.onClick} title={view.title}>
          <EyeOutlined /> {view.name}
        </span>
      ),
    });
  }

  if (downloadReport) {
    items.push({
      key: "downloadReport",
      label: (
        <a
          href={downloadReport.url}
          target="_blank"
          rel="noopener noreferrer"
          download
          title={downloadReport.title}
        >
          <FileProtectOutlined /> {downloadReport.name}
        </a>
      ),
    });
  }

  if (fillSurvey) {
    items.push({
      key: "fillSurvey",
      label: (
        <span onClick={fillSurvey.onClick} title={fillSurvey.title}>
          <BookOutlined /> {fillSurvey.name}
        </span>
      ),
    });
  }

  if (component) {
    items.push({
      key: "components",
      label: (
        <span onClick={component.onClick} title={component.title}>
          <FileAddOutlined /> {component.name}
        </span>
      ),
    });
  }

  if (subComponent) {
    items.push({
      key: "subComponents",
      label: (
        <span onClick={subComponent.onClick} title={subComponent.title}>
          <FileAddOutlined /> {subComponent.name}
        </span>
      ),
    });
  }

  if (openIssues) {
    items.push({
      key: "openIssues",
      label: (
        <span onClick={openIssues.onClick} title={openIssues.title}>
          <ExclamationCircleOutlined /> {openIssues.name}
        </span>
      ),
    });
  }

  if (edit) {
    items.push({
      key: "edit",
      label: (
        <span onClick={edit.onClick} title={edit.title}>
          <EditOutlined /> {edit.name}
        </span>
      ),
    });
  }

  if (onMapPreview) {
    items.push({
      key: "onMapPreview",
      label: (
        <span onClick={onMapPreview.onClick} title={onMapPreview.title}>
          <EyeOutlined /> {onMapPreview.name}
        </span>
      ),
    });
  }

  if (createSurvey) {
    items.push({
      key: "createSurvey",
      label: (
        <span onClick={createSurvey.onClick} title={createSurvey.title}>
          <FileProtectOutlined /> {createSurvey.name}
        </span>
      ),
    });
  }

  if (assignPermissions) {
    items.push({
      key: "assignPermissions",
      label: (
        <span onClick={assignPermissions.onClick} title={assignPermissions.title}>
          <UserSwitchOutlined /> {assignPermissions.name}
        </span>
      ),
    });
  }

  if (share) {
    items.push({
      key: "share",
      label: (
        <span onClick={share.onClick} title={share.title}>
          <ShareAltOutlined /> {share.name}
        </span>
      ),
    });
  }

  if (archive) {
    items.push({
      key: "archive",
      label: (
        <span
          data-testid={archive?.datatestid}
          onClick={archive.onClick}
          title={archive.title}
        >
          <DeleteOutlined /> {archive.name}
        </span>
      ),
    });
  }

  return (
    <Dropdown
      overlay={<Menu items={items} />}
      trigger={["click"]}
    >
      <Button
        shape="circle"
        size="large"
        data-testid="list-item-actions"
        icon={<MoreOutlined />}
        className="actionButton"
        title="More actions"
      />
    </Dropdown>
  );
};

/* props validation */
const actionShape = {
  name: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
};
ListItemActions.propTypes = {
  view: PropTypes.shape(actionShape),
  onMapPreview: PropTypes.shape(actionShape),
  edit: PropTypes.shape(actionShape),
  reload: PropTypes.shape(actionShape),
  share: PropTypes.shape(actionShape),
  archive: PropTypes.shape(actionShape),
  components: PropTypes.shape(actionShape),
  fillSurvey: PropTypes.shape(actionShape),
};

ListItemActions.defaultProps = {
  view: null,
  onMapPreview: null,
  edit: null,
  reload: null,
  share: null,
  archive: null,
  fillSurvey: null,
  components: null,
};

export default ListItemActions;
